<template>
  <div class="card-catalogue-page" v-if="actions">
    <CardCatalogue :catalogue="actions" />
  </div>
</template>

<script>
// Utils
import { categorize, sortObject } from 'Utils'
import { Notification } from 'Utils/Classes/Notification'
// Components
import CardCatalogue from 'Modules/Card/CardCatalogue'

export default {
  name: 'ActionsPage',

  components: {
    CardCatalogue,
  },

  data() {
    return {
      actions: null,
    }
  },

  methods: {
    close() {
      this.$store.dispatch('modal/close')
    },
  },

  computed: {
    account() {
      return this.$store.state.client.account
    },

    cardCatalogue() {
      return this.$store.state.cardCatalogue.catalogue
    },
  },

  async mounted() {
    try {
      if (!this.cardCatalogue || this.cardCatalogue[0].language !== this.account.language) {
        await this.$store.dispatch('cardCatalogue/loadCatalogue', this.$route.params.account_id)
      }
      const cardCatalogue = this.cardCatalogue

      const publishedTemplates = cardCatalogue.filter((template) => template.status === 'published')
      // Grouping and ordering templates by category
      let result = categorize(publishedTemplates, (template) => template.category)
      this.actions = sortObject(result)
      // Extending the modal's size
      this.$el.parentElement.classList.add('large')
    } catch (error) {
      const notification = new Notification()
      notification.timeout = 4000
      notification.message = this.$t('ui.notifications.error.actions_load')
      this.$router.back()
      notification.dispatch()
      console.error(error)
    }
  },
}
</script>

<style scoped>
.card-catalogue-page {
  width: 100%;
}

.actions {
  padding: 10px 10px 30px;
}

.action-close-btn {
  text-align: right;
}

.action-section:not(:first-of-type) {
  margin-top: 40px;
}
</style>
